export var centerContentGridColumnStates = [
    // When both leftContent and rightContent exist
    {
        predicate: function (leftContent, rightContent) { return Boolean(leftContent) && Boolean(rightContent); },
        gridColumn: 'span 1',
    },
    // When leftContent exists and rightContent doesn't exist or rightContent exists and leftContent doesn't exist
    {
        predicate: function (leftContent, rightContent) {
            return (Boolean(leftContent) && !rightContent) || (!leftContent && Boolean(rightContent));
        },
        gridColumn: 'span 2',
    },
    // When both leftContent and rightContent don't exist, centerContent becomes maximum size
    {
        predicate: function (leftContent, rightContent) { return !leftContent && !rightContent; },
        gridColumn: 'span 3',
    },
];
//# sourceMappingURL=centerContentGridColumnStates.js.map